<template>
  <BaseDialog centered contentClass="edit-tenant" ref="dialog" persistent :show-actions="true">
    <template slot="title">{{ $t('page.admin-tenants.edit-tenant') }}</template>
    <template slot="content">
      <span>
        {{
          $t('page.admin-tenants.edit-tenant-active', {
            state: $t(`page.admin-tenants.data.${this.active ? 'inactive' : 'active'}`),
            name: name,
          })
        }}</span
      >
      <form @click.prevent>
        <div class="edit-category__actions">
          <FormButton is-outlined class="edit-category__cancel" @click.native="cancelClick">{{
            $t('actions.cancel')
          }}</FormButton>
          <FormButton @click.native="onSubmit" type="submit">
            <span>{{ $t('dialog.filters.advanced.apply') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';

import { mapActions } from 'vuex';

export default {
  name: 'EditTenantDialog',
  components: {
    BaseDialog,
    FormButton,
  },
  data() {
    return {
      name: '',
      tenantId: '',
      active: false,
    };
  },
  methods: {
    ...mapActions('tenants', ['updateTenant']),
    openDialog(tenant) {
      (this.name = tenant.name), (this.tenantId = tenant.id);
      this.active = tenant.active;
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      this.updateTenant({ tenantId: this.tenantId, tenant: { active: !this.active } })
        .then(() => {
          this.$toast.success(this.$t('page.admin-tenants.edit-tenant-success'));
          this.$emit('action-succeeded');
          this.closeDialog();
        })
        .catch((error) => this.$toast.error(error));
    },
    cancelClick() {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__edit-tenant {
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.edit-category {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }

  &__action {
    text-transform: lowercase;
    font-weight: bold;
  }
}
</style>
